import React from 'react';
import axios from 'axios';
import { Button, Header, Popup, Icon, Tab, Responsive, Loader } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import { IconHeader, FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import BasicCourses from '../CreateStudyProgramImplementation/BasicCourses';
import Filters from '../CreateCourse/Filters';
import SemesterAddedCourses from '../CreateStudyProgramImplementation/SemesterAddedCourses';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class SemesterCourses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true
        };
    }

    componentDidMount() {
        let orgUnitId = parseInt(localStorage.getItem('orgUnitId'), 10);
        if (!orgUnitId) orgUnitId = parseInt(localStorage.getItem('orgUnit'), 10);

        !this.props.studentService && axios.get(`course/basic/${orgUnitId}/false`)
            .then(res => {
                this.setState({ data: res.data, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch courses');
            });
    }


    render() {
        const panes = [
            {
                menuItem: 'Predmeti na semestru',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <SemesterAddedCourses
                        sPsemesterId={this.props.sPsemesterId}
                        semesterId={this.props.semesterId}
                        newSPId={this.props.newSPId}
                        semesters={this.props.semesters}
                        getSemesters={this.props.getSemesters}
                        semesterNumber={this.props.semesterNumber}
                    /></Tab.Pane>)
            },
            (localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && (localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta') &&
            {
                menuItem: 'Predmeti koji se mogu dodati na semestar',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    { this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                        : <BasicCourses
                            data={this.state.data}
                            sPsemesterId={this.props.sPsemesterId}
                            semesterId={this.props.semesterId}
                            newSPId={this.props.newSPId}
                            getSemesters={this.props.getSemesters}
                            addCourseSemestersAfter
                            studentSerice
                        />}
                </Tab.Pane>)
            }
        ];

        return (
            <div>
                {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && (localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta') && <Header as="h3">Predmeti na semestru
                </Header>}

                {this.props.studentService ?
                    <SemesterAddedCourses
                        sPsemesterId={this.props.sPsemesterId}
                        semesterId={this.props.semesterId}
                        newSPId={this.props.newSPId}
                        semesters={this.props.semesters}
                        getSemesters={this.props.getSemesters}
                        semesterNumber={this.props.semesterNumber}
                        studentService
                        changeSemester
                    />
                    : <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} defaultActiveIndex={0} />}

            </div>
        );
    }
}

export default SemesterCourses;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/SemesterCourses.js